export const types = {
    REGISTRATION_REQUEST: 'REGISTRATION_REQUEST',
    REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
    REGISTRATION_FAILURE: 'REGISTRATION_FAILURE',
    IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST: 'IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST',
    IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_SUCCESS: 'IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_SUCCESS',
    IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE: 'IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE',
};
